import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: lang,
	fallbacklocale: 'en',
  messages: {
    en:{
      tour_step1: 'Welcome to the Image Explorer! Learn about what is hidden in our universe by viewing images through a polarized filter.',
      tour_step2: 'Images are made of data and contain hidden information. Select an image and adjust these filters to reveal the additional data.',
      tour_step3: 'A polarized filter will only allow light that is oriented in the same direction (polarized light) to pass through. Adjust the orientation of the filter to change the image.',
      // tour_step4: 'This is an info button.',
      tour_step5: 'Get more details about the image and find out what you can learn from the polarized image.',
      tour_step7: 'Want to learn more? Click here to access more content.',
      tour_step6: 'Take the tour again by clicking here.',
			tour_skip: 'Skip tour',
      tour_prev: 'Previous',
      tour_next: 'Next',
      tour_finish: 'Finish',
      info_button_slider: 'Light can be pictured as a wave of oscillating electric and magnetic fields. If the electric fields are all oriented in the same direction, we say the light is polarized. Polarization gives us insight into the source of the light and the material (including magnetic fields) it has passed through.',
      info_button_contrast: 'polarization contrast',
    },
    fr:{
      tour_step1: 'Bienvenue dans l’Explorateur d’images! Découvrez ce qui est caché dans notre univers en regardant des images à travers un filtre polarisant.',
      tour_step2: 'Les images sont constituées de données et contiennent de l’information cachée. Sélectionnez une image et réglez ces filtres pour révéler des données supplémentaires.',
      tour_step3: 'Un filtre polarisant laisse passer uniquement la lumière qui est orientée dans la même direction (lumière polarisée). Réglez l’orientation du filtre pour modifier l’image.',
      // tour_step4: 'Il s agit d un bouton d information.',
      tour_step5: 'Obtenez plus de détails sur l’image, et voyez ce que l’image polarisée peut vous apprendre.',
      tour_step7: 'Vous voulez en savoir plus? Cliquez ici pour accéder à davantage de contenu.',
      tour_step6: 'Cliquez ici pour refaire la visite guidée.',
      tour_skip: 'Ignorer',
      tour_prev: 'Précédent',
      tour_next: 'Suivant',
      tour_finish: 'Terminer',
      info_button_slider: 'La lumière peut être représentée comme une onde formée de champs électrique et magnétique oscillants. Si tous les champs électriques d’un faisceau lumineux sont orientés dans la même direction, on dit que la lumière est polarisée. La polarisation donne des renseignements sur la source de la lumière et les matériaux (y compris les champs magnétiques) qu’elle a traversés.',
      info_button_contrast: 'polarization contrast',
    }
  }

})
